/*
 * Configuracion de validaciones de lista para celdas de la hoja.
 * Cada entrada define que columna se valida, contra que lista de dominios,
 * y que mensaje de error mostrar. POO: se usa con newDataValidation de Univer.
 */
import type { ListValidationConfig } from '../../shared/verteoffice'

export const LIST_VALIDATION_CONFIGS: ListValidationConfig[] = [
  {
    columnKey: 'user_name',
    listKey: 'usersList',
    errorMessage: 'select_valid_user'
  },
  {
    columnKey: 'user_autorization',
    listKey: 'usersList',
    errorMessage: 'select_valid_authorizer'
  },
  {
    columnKey: 'company_name',
    listKey: 'companiesList',
    errorMessage: 'select_valid_company'
  },
  {
    columnKey: 'product',
    listKey: 'productList',
    errorMessage: 'select_valid_product'
  },
  {
    columnKey: 'general_activity',
    listKey: 'generalActivityList',
    errorMessage: 'select_valid_general_activity',
    entryPolicy: 'canonicalize-and-reject-invalid',
    matchMode: 'normalized'
  },
  {
    columnKey: 'specific_activity',
    sources: [
      'activityObjectiveAtentionList',
      'activityObjectiveCommunicationList',
      'activityObjectiveDataDevList',
      'activityObjectiveStructureProcessList',
      'activityObjectiveMngProcessesList',
      'activityObjectivePlanStrategyList',
      'activityObjectiveReportingList',
      'activityObjectiveHumanTalentAbsenteeismList'
    ],
    errorMessage: 'select_valid_specific_activity',
    entryPolicy: 'canonicalize-and-reject-invalid',
    matchMode: 'normalized'
  },
  {
    columnKey: 'activity_objective',
    sources: [
      'specificActivityAttentionSoliList',
      'specificActivityAttentionTableList',
      'specificActivityDesignList',
      'specificActivitySupportList',
      'specificActivityDevList',
      'specificActivityCapacityList',
      'specificActivityModelBiList',
      'specificActivityTableBiList',
      'specificActivityStandardList',
      'specificActivityInstructiveList',
      'specificActivityOperationList',
      'specificActivityAdminthList',
      'specificActivityCapDevList',
      'specificActivityContFinList',
      'specificActivityMngAdminList',
      'specificActivityDevBusinessInnovationList',
      'specificActivityCultureWellbeingList',
      'specificActivityCampaignCallingList',
      'specificActivityMngContractList',
      'specificActivityMngDisengagementList',
      'specificActivityMngEcoeficienciaList',
      'specificActivityMngPaymentsList',
      'specificActivityMngReportingList',
      'specificActivityMngSelEngContrtList',
      'specificActivityMngSustainabilityList',
      'specificActivityPerformanceList',
      'specificActivityMngDocumentThList',
      'specificActivityMngFutureVList',
      'specificActivityMngInductionReductionList',
      'specificActivityMngMarketTariffsList',
      'specificActivityMngPlanningList',
      'specificActivityMngSolutionTechList',
      'specificActivityInternalList',
      'specificActivitySgSstList',
      'specificActivitySystemMngIntegralList',
      'specificActivityVertebraHelpInternalList',
      'specificActivityAlignStrategyList',
      'specificActivityCoordinationAreasList',
      'specificActivityDirectionTeamList',
      'specificActivityStrategyCompanyList',
      'specificActivityReportsEcoeficienciaList',
      'specificActivityReportsInternalList',
      'specificActivityReportsMarketTarrifsList',
      'specificActivityReportsPaymentsList',
      'specificActivityReportsSolutionsTechList',
      'specificActivityAbsentWorkList',
      'specificActivityCulturalVertebraList',
      'specificActivityDisengagementList',
      'specificActivityInductionReinductionList',
      'specificActivitySelectionList',
      'specificActivitySystemMngList'
    ],
    errorMessage: 'select_valid_activity_objective',
    entryPolicy: 'canonicalize-and-reject-invalid',
    matchMode: 'normalized'
  },
  {
    columnKey: 'activity_type',
    listKey: 'activityTypePendingList',
    errorMessage: 'select_valid_activity_type'
  },
  {
    columnKey: 'request_source',
    listKey: 'requestSourcePendingList',
    errorMessage: 'select_valid_request_source'
  },
  {
    columnKey: 'status',
    listKey: 'statusPendingList',
    errorMessage: 'select_valid_status'
  }
]
